/**
 * 文件说明:
 *
 * hz Sentry component
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import React from 'react'
import * as Sentry from 'utils/sentry'
import {Result, Button} from 'antd'

class Raven extends React.Component {
    constructor(props) {
        super(props)
        this.state = {isError: false}
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope((scope) => {
            scope.setExtras(errorInfo)
            Sentry.captureException(error)
            this.setState({
                isError: true,
            })
        })
    }

    refresh = () => {
        window.location.reload()
    }

    render() {
        const {isError} = this.state

        if (isError) {
            return (
                <Result
                    status="500"
                    title="500"
                    subTitle="Sorry, the server is wrong."
                    extra={
                        <Button type="primary" onClick={this.refresh}>
                            刷新重试
                        </Button>
                    }
                />
            )
        }

        return this.props.children
    }
}

export function rootContainer(container) {
    return React.createElement(Raven, null, container)
}
